// src/components/plan/PlanStartedPage.jsx
// Pooled inbox SP5 — /plan/started, Your free month has started (proto
// plan/confirm.html). Draws the `receipt` POST /billing/start-trial answered,
// handed over in the router state (it survives a reload in the same tab);
// without one there is nothing to show and the client lands on the dashboard.
// No Plaid on this page (spec § Removals). No date (prototype: "No date is
// shown"; the first-charge date is on Profile, owner item 18).
import React, { useEffect, useRef } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Button } from "../ui";
import Ledger from "./Ledger";
import PlanLayout from "./PlanLayout";
import {
  GO_TO_DASHBOARD,
  LEDGER_CHARGED_TODAY,
  LEDGER_FIRST_MONTH,
  LEDGER_FREE,
  LEDGER_PLAN_TITLE,
  LEDGER_SETUP_FEE,
  LEDGER_THEN,
  LEDGER_THEN_RETURNING,
  LEDGER_WAIVED,
  MESSAGE_ADVISORS,
  STARTED_BODY,
  STARTED_BODY_RETURNING,
  STARTED_TITLE,
  STARTED_TITLE_RETURNING,
  money,
} from "./planCopy";

export const receiptRows = ({ priceCents, chargedTodayCents, freeMonth }) => [
  ...(freeMonth ? [{ label: LEDGER_FIRST_MONTH, value: LEDGER_FREE }] : []),
  { label: LEDGER_SETUP_FEE, value: LEDGER_WAIVED },
  {
    label: LEDGER_CHARGED_TODAY,
    value: money(chargedTodayCents),
    kind: "total",
  },
  {
    label: freeMonth ? LEDGER_THEN : LEDGER_THEN_RETURNING,
    value: money(priceCents),
    kind: "then",
  },
];

export default function PlanStartedPage() {
  const { state } = useLocation();
  const receipt = state?.receipt;
  const h1 = useRef(null);
  useEffect(() => {
    h1.current?.focus();
  }, []);
  if (!receipt) return <Navigate to="/dashboard" replace />;

  const free = receipt.freeMonth;
  return (
    <PlanLayout>
      <div className="tw-grid tw-justify-items-center tw-gap-4 tw-text-center">
        <span
          aria-hidden="true"
          className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-pill tw-bg-success tw-text-xl tw-text-on-accent"
        >
          ✓
        </span>
        <h1
          ref={h1}
          tabIndex={-1}
          className="tw-m-0 tw-text-2xl tw-font-bold focus:tw-outline-none"
        >
          {free ? STARTED_TITLE : STARTED_TITLE_RETURNING}
        </h1>
        <p className="tw-m-0 tw-max-w-md tw-text-md tw-text-text-muted">
          {free
            ? STARTED_BODY(receipt.planName)
            : STARTED_BODY_RETURNING(receipt.planName)}
        </p>
        <section
          aria-labelledby="plan-started-receipt"
          className="tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-bg-surface tw-p-6 tw-text-left"
        >
          <h2
            id="plan-started-receipt"
            className="tw-mb-4 tw-mt-0 tw-text-lg tw-font-bold"
          >
            {LEDGER_PLAN_TITLE(receipt.planName)}
          </h2>
          <Ledger rows={receiptRows(receipt)} />
        </section>
        <div className="tw-mt-2 tw-grid tw-justify-items-center tw-gap-6">
          <Button as={Link} to="/thread">
            {MESSAGE_ADVISORS} <span aria-hidden="true">→</span>
          </Button>
          <Button as={Link} to="/dashboard" variant="text">
            {GO_TO_DASHBOARD}
          </Button>
        </div>
      </div>
    </PlanLayout>
  );
}
